import React from 'react';
import cn from 'classnames';
import { scroller } from 'react-scroll';

import style from './HeaderItem.module.css';

interface Props {
  children: React.ReactNode;
  to: string;
  id: number;
  className?: string;
  onClick: (id: number) => void;
  scroll: (to: string) => void;
}

function HeaderItem2({ children, to, id, className, onClick, scroll }: Props): JSX.Element {
  const handleClick = () => {
    // scroller.scrollTo(to, {
    //   duration: 800,
    //   smooth: true,
    //   offset: 0,
    // });
    scroll(to);
    onClick(id);
  };

  return (
    <li onClick={handleClick} className={style.HeaderItem}>
      {children}
    </li>
  );
}
export default HeaderItem2;
